// SEO Data generated from Excel
// This is the complete SEO configuration for all domains

export const SEO_DATA = {
  'gcctaxlaws.com': {
    '/': {
      title: 'GCC Tax Laws & Tax Treaties (DTAA)',
      description:
        'Search official text of GCC tax laws and tax treaties: UAE VAT & Corporate Tax, Saudi/KSA VAT & Income Tax , transfer pricing, customs, and excise',
      keywords:
        'UAE VAT, UAE Corporate Tax, Saudi VAT, Zakat KSA, GCC tax treaties, Transfer pricing UAE, Customs GCC, Excise tax GCC, Free zone corporate tax UAE, UAE TRC',
      h1: 'Your go-to tax research platform',
      h2: 'Authoritative GCC tax laws and treaty research',
      h3: 'UAE VAT & Corporate Tax: law, guides, decisions\n\nSaudi VAT & Zakat: regulations, circulars, rulings\n\nTreaties: dividends, interest, royalties, PE, relief\n\nTransfer pricing: UAE/KSA requirements and guides\n\nCustoms & excise: GCC framework and local rules\n\nBahrain, Kuwait, Oman, Qatar Tax regulations',
    },
    '/about-us': {
      title: 'GCC tax law research tool',
      description:
        'We publish GCC tax laws and tax treaties from official texts, structured with article-level navigation, filters, cross-references, and update tracking',
      keywords:
        'GCC tax laws, UAE VAT, UAE corporate tax, UAE CIT, Saudi VAT, Zakat KSA, tax treaties, transfer pricing, UAE customs, Saudi Customs, excise',
    },
    '/partner-with-us': {
      title: 'Partner with GCCtaxlaws.com | Data licensing and APIs',
      description:
        'License GCC tax law content built from official texts. Embed via API, enable SSO and bulk access, co-brand training, and power your research tools.',
      keywords:
        'data licensing, API, SSO, bulk seats, site license, white label, content embedding, tax treaty data, transfer pricing data, enterprise integration, co-branded training',
    },
    '/contact-us': {
      title: 'Contact GCCtaxlaws.com | Support, Licensing & API',
      description:
        'Reach GCCtaxlaws.com for support, sales and partnerships. Ask about licensing, API feeds, and structured GCC tax texts on VAT, Corporate Tax, and treaties.',
      keywords:
        'support, sales, licensing, API, site license, bulk seats, SSO, SCIM, enterprise, data syndication, correction request, partnerships, media',
    },
    '/features': {
      title: 'Features | GCC Tax Laws Research Tools',
      description:
        'Official GCC tax texts, parsed and structured with article-level navigation, powerful search, filters, cross-references, and update history across VAT, CIT, Zakat, customs, excise, treaties.',
      keywords:
        'official texts, structured articles, article-level navigation, search filters, cross-references, update history, UAE VAT, UAE corporate tax, Saudi VAT, Zakat, customs, excise, treaties',
      h1: 'GCC Tax Features',
      h2: 'Built from official GCC texts, structured for fast, reliable research. GCCTaxLaws.com parses and organizes UAE, Saudi, Qatar, Bahrain, Kuwait, and Oman tax sources into an article-level experience with jump links, cross-references across laws and treaties, and fast search with smart filters,backed by update tracking and clear release notes so you can see what changed and when.',
    },
    '/pricing': {
      title: 'GCC Tax Laws Pricing | Individual, Team, Firm, Enterprise',
      description:
        'Unlock structured GCC tax texts: tax treaty, VAT, corporate tax, Zakat, customs, excise, and treaties. Team and enterprise licenses with options for API and SSO.',
      keywords:
        'enterprise access, team access, role-based seats, content exports, saved views, API, SSO, IP control, procurement, quote, VAT, CIT, Zakat, customs, excise, DTAA',
      h1: 'Pricing, plans & subscriptions',
      h2: "Get complete access to GCC tax laws and all 6 GCC countries' tax treaties (as and when made available on the portal)",
    },
    '/search-across-law': {
      title: 'Search GCC Laws & Treaties | VAT, Corporate Tax, Zakat',
      description:
        'Select a jurisdiction and tax law to search structured GCC tax texts. Article-level navigation, filters, cross-references for UAE, Saudi, KSA Qatar, Bahrain, Kuwait, Oman.',
      keywords:
        'GCC tax search, UAE VAT search, UAE corporate tax search, Saudi VAT search, Zakat, customs, excise, treaties, article-level, filters, cross-references, treaty search, DTAA search',
    },
    '/blogs': {
      title: 'GCC Tax Blog | Treaties, VAT, Corporate Tax, Transfer Pricing',
      description:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
      keywords:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
    },
    '/news': {
      title: 'GCC Tax News | Latest Tax Updates Across the Gulf',
      description:
        'Stay updated with the latest tax news from UAE, Saudi Arabia, Kuwait, Qatar, Oman, and Bahrain. Real-time tax authority announcements and regulatory updates from FTA, ZATCA, GTA, NBR and more.',
      keywords:
        'GCC tax news, UAE tax news, Saudi tax news, ZATCA news, FTA news, Kuwait tax news, Qatar tax news, GTA news, Oman tax news, Bahrain tax news, NBR news, tax authority announcements, regulatory updates, VAT news, corporate tax news, DMTT updates',
    },
    '/news/uae': {
      title: 'UAE Tax News | FTA Announcements & Regulatory Updates',
      description:
        'Latest UAE tax news and Federal Tax Authority (FTA) announcements. VAT, Corporate Tax (CIT), DMTT, excise and customs updates from official UAE tax authority sources.',
      keywords:
        'UAE tax news, FTA news, Federal Tax Authority announcements, UAE VAT news, UAE Corporate Tax news, CIT UAE updates, UAE DMTT news, Pillar Two UAE, excise UAE updates, UAE tax regulatory updates, UAE tax alerts',
    },
    '/news/ksa': {
      title: 'Saudi (KSA) Tax News | ZATCA Announcements & Updates',
      description:
        'Latest Saudi Arabia (KSA) tax news and ZATCA announcements. VAT, Corporate Income Tax, Zakat, e-invoicing, excise and customs updates from ZATCA official sources.',
      keywords:
        'Saudi tax news, KSA tax news, ZATCA news, ZATCA announcements, Saudi VAT news, Saudi corporate tax news, Zakat news, e-invoicing Saudi, KSA excise updates, Saudi tax regulatory updates',
    },
    '/news/kuwait': {
      title: 'Kuwait Tax News | Government Announcements & Updates',
      description:
        'Latest Kuwait tax news and Kuwait Government Online announcements. Corporate income tax, DMTT, Zakat/NLST/KFAS, customs and treaty updates from official Kuwait sources.',
      keywords:
        'Kuwait tax news, Kuwait Government Online news, Kuwait DMTT updates, Kuwait Pillar Two news, Kuwait corporate tax news, NLST Kuwait, KFAS Kuwait, Zakat Kuwait news, Kuwait customs updates, Kuwait tax regulatory alerts',
    },
    '/news/qatar': {
      title: 'Qatar Tax News | General Tax Authority (GTA) Updates',
      description:
        'Latest Qatar tax news and General Tax Authority (GTA) announcements. Income tax, DMTT, excise tax and customs updates from official Qatar tax authority sources.',
      keywords:
        'Qatar tax news, GTA news, General Tax Authority Qatar, Qatar income tax news, Qatar DMTT updates, Pillar Two Qatar, Qatar excise news, Qatar customs updates, Qatar tax regulatory alerts, Qatar tax announcements',
    },
    '/news/oman': {
      title: 'Oman Tax News | Oman Tax Authority Announcements',
      description:
        'Latest Oman tax news and Oman Tax Authority announcements. VAT, income tax, excise and customs regulatory updates from official Oman tax authority sources.',
      keywords:
        'Oman tax news, Oman Tax Authority news, Oman VAT news, Oman income tax news, Oman excise updates, Oman customs news, Oman tax regulatory updates, Oman tax alerts, Royal Decree Oman tax',
    },
    '/news/bahrain': {
      title: 'Bahrain Tax News | NBR Announcements & Updates',
      description:
        'Latest Bahrain tax news and National Bureau for Revenue (NBR) announcements. VAT, DMTT, excise and customs regulatory updates from official Bahrain tax authority sources.',
      keywords:
        'Bahrain tax news, NBR news, National Bureau for Revenue announcements, Bahrain VAT news, Bahrain DMTT updates, Pillar Two Bahrain, Bahrain excise news, Bahrain customs updates, Bahrain tax regulatory alerts',
    },
    '/search/UAE/Tax-Treaties': {
      title: 'UAE Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Search official text of UAE tax treaties by partner country. Article level pages, filters, and official texts covering withholding, PE, capital gains, and relief.',
      keywords:
        'UAE tax treaties, UAE DTT, UAE DTAA, double taxation agreements UAE, treaty list UAE, withholding tax UAE treaty, PE UAE treaty, capital gains article 13 UAE, residency tie-breaker, tax credit article 23, dividends interest royalties UAE, PE, Permanent Establishment, Profit attribution',
    },
    '/search/KSA/Tax-Treaties': {
      title: 'Saudi (ksa) Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Search official text of Saudi (ksa) tax treaties by partner country. Article level pages, filters, and official texts covering withholding, PE, capital gains, and relief.',
      keywords:
        'ksa tax treaties, ksa DTT, ksa DTAA, double taxation agreements ksa, treaty list ksa, withholding tax ksa treaty, PE ksa treaty, capital gains article 13 ksa, residency tie-breaker, tax credit article 23, dividends interest royalties ksa, PE, Permanent Establishment, Profit attribution',
    },
    '/search/Kuwait/Tax-Treaties': {
      title: 'kuwait Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Search official text of kuwait tax treaties by partner country. Article level pages, filters, and official texts covering withholding, PE, capital gains, and relief.',
      keywords:
        'kuwait tax treaties, kuwait DTT, kuwait DTAA, double taxation agreements kuwait, treaty list kuwait, withholding tax kuwait treaty, PE kuwait treaty, capital gains article 13 kuwait, residency tie-breaker, tax credit article 23, dividends interest royalties kuwait, PE, Permanent Establishment, Profit attribution',
    },
    '/search/Qatar/Tax-Treaties': {
      title: 'Qatar Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Explore official text of Qatar’s double taxation treaties by partner country. Article-level pages with filters and official texts for WHT, PE, capital gains, and relief.',
      keywords:
        'Qatar tax treaties, Qatar DTT, Qatar DTAA, double taxation agreements Qatar, treaty list Qatar, withholding tax Qatar treaty, PE Qatar treaty, capital gains article 13 Qatar, residency tie-breaker, tax credit article 23',
    },
    '/search/Oman/Tax-Treaties': {
      title: 'Oman Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Search official text of Oman tax treaties by partner country. Article-level navigation, filters, and official texts covering withholding, PE, capital gains, and relief.',
      keywords:
        'Oman tax treaties, Oman DTT, Oman DTAA, double taxation agreements Oman, treaty list Oman, withholding tax Oman treaty, PE Oman treaty, capital gains article 13 Oman, elimination of double taxation, treaty index Oman',
    },
    '/search/Bahrain/Tax-Treaties': {
      title: 'Bahrain Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Find Bahrain official text tax treaties by partner country. Use filters and text search to open article-level pages on WHT, PE, capital gains, and methods of relief.',
      keywords:
        'Bahrain tax treaties, Bahrain DTT, Bahrain DTAA, double taxation agreements Bahrain, treaty list Bahrain, withholding tax Bahrain treaty, PE Bahrain treaty, capital gains article 13 Bahrain, residency tie-breaker, tax credit article 23',
    },
    '/laws/GCC/common-customs-agreement': {
      title: 'GCC Common Customs Agreement | Customs union rules & procedures',
      description:
        'Official GCC Common Customs Agreement, parsed and structured: scope, valuation, classification, duty rates, exemptions, origin, transit, warehousing, procedures, penalties, appeals.',
      keywords:
        'GCC Common Customs Agreement, GCC customs union, customs valuation, tariff classification, duty rates, exemptions, rules of origin, transit, warehousing, customs procedures, penalties, appeals',
    },
    '/laws/GCC/common-vat-agreement': {
      title: 'GCC Common VAT Agreement | Unified VAT framework',
      description:
        'Unified GCC VAT framework parsed and structured: scope, place of supply, rates and exemptions, registration, reverse charge, intra GCC trade, refunds and compliance.',
      keywords:
        'GCC Common VAT Agreement, Unified VAT Agreement for the GCC, GCC VAT, place of supply, zero rated supplies, exemptions, VAT registration, VAT groups, reverse charge, intra GCC supplies, imports and exports, input tax refunds, invoicing and records, penalties and disputes',
    },
    '/laws/GCC/common-excise-agreement': {
      title: 'GCC Common Excise Agreement | Selective tax framework',
      description:
        'Unified GCC excise framework: taxable goods and rates, registration, warehouses & suspension, declarations & payment, tax stamps, penalties and refunds.',
      keywords:
        'GCC Common Excise Agreement, GCC excise tax, selective tax GCC, taxable goods, excise rates, registration and licensing, excise warehouse, suspension arrangement, declarations, payment, tax stamps, digital tax stamps, track and trace, offences and penalties, refunds, exemptions, imports and exports, coordination with customs',
    },
    '/laws/uae/cit-fdl-47-of-2022': {
      title: 'UAE Corporate Tax (CIT) | Law, Decisions, Guides',
      description:
        'Search UAE Corporate Tax law and decisions with article-level navigation, updates, and practical guides: registration, filing, free-zone rules, TP, reliefs.',
      keywords:
        'UAE Tax, UAE Corporate Tax, CIT UAE 9%, Federal Decree-Law 47/2022, Cabinet Decisions, Ministerial Decisions, Qualifying Free Zone Person, QFZP, Qualifying Income, Small Business Relief, TP UAE, Master file, Local file, CbCR, Interest deduction limitation, Participation exemption, Foreign tax credit, Tax groups, Loss relief, Business restructuring, Registration, Filing, DMTT, Pillar two UAE',
    },
    '/laws/uae/dmtt-fdl-60-of-2023': {
      title: 'UAE DMTT (FDL No 60 of 2023) | Law, Decisions, Guides',
      description:
        'Search UAE Global Minimum Tax (DMTT/Pillar Two) law and decisions with article-level navigation, updates, and practical guides: MNE scope, top-up tax calculation, safe harbours, and filings.',
      keywords:
        'UAE DMTT, Federal Decree-Law 60 of 2023, Global Minimum Tax UAE, Pillar Two, Top-up Tax, MNE Groups, GloBE Rules, QDMTT, Multinational Enterprises, 15% effective tax rate',
    },
    '/laws/uae/indirecttax-law-vat-uaevat-8-of-2017-as-amended': {
      title: 'UAE VAT | Law, Decisions, Guide, Returns, Invoicing',
      description:
        'Official UAE VAT texts parsed and structured: law, regulations, decisions, guides and public clarifications. Coverage includes registration, returns, invoicing and refunds.',
      keywords:
        'UAE VAT, VAT UAE guidance, executive regulations, FTA public clarifications, registration threshold, VAT returns UAE, tax invoices, credit notes, input tax recovery, refund procedures, penalties UAE VAT, reverse charge UAE, zero rate, exemption',
    },
    '/laws/uae/tp-fdl-28-of-2022-as-amended': {
      title: 'UAE Tax Procedures | Law, Executive Regulation',
      description:
        'Search UAE Tax Procedures with article-level navigation: assessments, audits, penalties, voluntary disclosure, reconsideration, objections, appeals, and time limits.',
      keywords:
        'UAE Tax Procedures Law, Executive Regulation, FTA, assessments, tax audit, voluntary disclosure, administrative penalties, reconsideration, objection, appeal, time limits, limitation period, record keeping, information requests, payment, refunds, guarantees, enforcement',
    },
    '/laws/uae/indirect-excise-7-of-2017-as-amended': {
      title: 'UAE Excise Tax Law | Decree-Law 7 of 2017 | Rates & Goods',
      description:
        'Search Federal Decree-Law No. 7 of 2017 on Excise Tax. Article-level navigation for taxable goods, rates, registration, tax liability, stockpiling, and penalties.',
      keywords:
        'UAE Excise Law, Federal Decree-Law 7 of 2017, excise tax rates, tobacco tax, energy drinks, carbonated drinks, sweetened beverages, excise registration, tax warehouse, digital tax stamps, DTS',
    },
    '/laws/uae/fatca-of-2024': {
      title: 'UAE FATCA Compliance 2024 | Regulations & Reporting Guidelines',
      description:
        'Authoritative UAE FATCA reporting hub for 2024. Access official guidance, IGA text, due diligence rules, and submission procedures for Financial Institutions.',
      keywords:
        'UAE FATCA 2024, Foreign Account Tax Compliance Act, MoF FATCA guidance, Regulatory Authorities, IGA Model 1, CRS FATCA portal, US indicia, financial institution reporting, due diligence',
    },
    '/laws/uae/crs-federal-decree-48-of-2018': {
      title: 'UAE Common Reporting Standard (CRS) | Regulations & Guidance',
      description:
        'Comprehensive guide to UAE CRS regulations. Access Federal Decree-Laws, Cabinet Decisions, and guidance for Financial Institutions on due diligence and reporting.',
      keywords:
        'UAE CRS, Common Reporting Standard UAE, Automatic Exchange of Information, AEOI UAE, FATCA CRS UAE, UAE Portal, Financial Institutions, Reportable Accounts, Due Diligence, CRS Guidance Notes, CRS Compliance, Reporting Financial Institution, Non-Reporting Financial Institution, UAE Ministry of Finance CRS',
    },
    '/laws/ksa/income-tax-law-of-2004': {
      title:
        'Saudi (KSA) Corporate Income Tax | Law, TP, Withholding, Guidance',
      description:
        'Search Saudi (KSA) corporate income tax law and regulations with article-level navigation, updates and guides: registration, returns, withholding, PE and transfer pricing.',
      keywords:
        'Saudi Tax, KSA Corporate Income Tax, Saudi CIT, ZATCA, Income Tax Law 2004, Implementing Regulations, withholding tax KSA, permanent establishment KSA, non-resident taxation, transfer pricing bylaws, master file, local file, CbCR, deductibility rules, loss carryforward, returns and payments, objections and appeals, DMTT, Pillar two Saudi (KSA)',
    },
    '/laws/ksa/vat-law-m-113-of-2017': {
      title: 'Saudi (KSA) VAT | Registration, Returns, Refunds, E-invoicing',
      description:
        'Official Saudi VAT texts parsed and structured. Coverage includes registration, return filing, e-invoicing, input tax refunds, penalties and dispute steps.',
      keywords:
        'Saudi VAT, KSA VAT, ZATCA, Implementing Regulations, e-invoicing FATOORA, registration, returns, payments, refunds, input tax, zero rated, exempt supplies, reverse charge, imports, penalties, audits, objections, appeals, public decisions, guides',
    },
    '/laws/ksa/excise-law-of-2019': {
      title: 'Saudi (KSA) Excise Tax Law | Rates, Goods, Returns',
      description:
        'Official Saudi Excise Tax Law (Royal Decree M/86) and amendments (including 2019 sweetened beverages). Coverage: taxable goods, rates, tax base, registration, returns and penalties.',
      keywords:
        'Saudi Excise Tax Law, KSA Excise Law, Royal Decree M/86, excise goods KSA, sweetened beverages tax, tobacco tax Saudi, energy drinks tax, tax stamps, excise registration, transitional rules',
    },
    '/laws/ksa/zakat-law-of-1951': {
      title: 'Saudi (KSA) Zakat Law | Decree 17/2/28/8634 of 1951',
      description:
        'Search the foundational Zakat Collection Law (1951) and modern Implementing Regulations. Coverage includes Zakat base calculation, adjusted net profit, deductions, and collection procedures.',
      keywords:
        'Saudi Zakat Law, Zakat Collection Law 1951, Royal Decree 17/2/28/8634, Zakat regulations KSA, Zakat base, adjusted net profit, Zakat 2.5%, legitimate expenses, Zakat collection',
    },
    '/laws/ksa/customs-law': {
      title: 'Saudi (KSA) Customs Law | GCC Common Customs Law',
      description:
        'Official KSA implementation of the Common Customs Law of the GCC States. Rules for import/export, customs valuation, tariff classification, prohibitions, and clearance procedures.',
      keywords:
        'Saudi Customs Law, Common Customs Law of the GCC, KSA customs procedures, customs valuation, tariff classification, harmonized system, customs duties KSA, temporary admission, customs exemptions, bayern',
    },
    '/laws/ksa/fatca-of-2017': {
      title: 'Saudi (KSA) FATCA Regulations | US Tax Compliance',
      description:
        'Official Saudi regulations for FATCA (ratified by Royal Decree M/52 of 2017). Compliance for financial institutions, US reportable accounts, due diligence, and IGA reporting standards.',
      keywords:
        'Saudi FATCA regulations, Royal Decree M/52, US tax compliance KSA, Foreign Account Tax Compliance Act, IGA Saudi USA, financial institutions reporting, due diligence, reportable accounts, TIN requirements',
    },
    '/laws/kuwait/kit-law-no-2-of-2008-amending-decree-no-3-of-1955': {
      title: 'Kuwait Corporate Income Tax | Law, Rules, Returns',
      description:
        'Search Kuwait corporate income tax law and executive rules with article-level navigation: registration, returns, payments, tax retention and clearance, PE, treaties.',
      keywords:
        'Kuwait Tax, Kuwait corporate income tax, Kuwait income tax decree, executive rules, tax registration Kuwait, tax return Kuwait, tax retention, tax retention 5% Kuwait, tax clearance certificate, permanent establishment Kuwait, non-resident taxation Kuwait, Kuwait tax treaties, objections and appeals, Retention Release Letter, No Objection Letter, Tax Clearance Certificate, TCC',
    },
    '/laws/kuwait/qdmtt-decree-law-157-of-2024': {
      title: 'Kuwait DMTT (QDMTT) | Pillar Two Top-Up Tax',
      description:
        'Authoritative Kuwait QDMTT hub: article-level law, scope, computation, safe harbours, filing and payment steps, and links to official guidance and updates.',
      keywords:
        'Kuwait DMTT, Kuwait QDMTT, Pillar Two Kuwait, domestic minimum top-up tax, top-up tax Kuwait, GloBE Kuwait, safe harbour, returns and payments, penalties, interaction with Kuwait income tax, treaty relief',
    },
    '/laws/kuwait/draft-business-profit-tax-law-of-2024': {
      title: 'Kuwait Draft Business Profits Tax Law 2024 | 15% CIT Proposal',
      description:
        'Overview of the Draft Business Profits Tax Law (BPT) in Kuwait: proposed 15% corporate tax rate, scope for local and foreign companies, exemptions for small businesses, and implementation timeline.',
      keywords:
        'Kuwait Draft Business Profits Tax Law, Kuwait BPT 2024, proposed corporate tax Kuwait 15%, Kuwait corporate income tax draft, Pillar Two Kuwait, withholding tax Kuwait draft, tax exemptions small business Kuwait',
    },
    '/laws/qatar/income-tax-law-24-of-2018': {
      title: 'Income Tax Law 24 of 2018 | Corporate Tax, Withholding',
      description:
        'Search Qatar Income Tax Law 24 of 2018 with article-level navigation: corporate tax rates, withholding, exemptions, penalties and Dhareiba filings.',
      keywords:
        'Income Tax Law 24 of 2018, Qatar corporate tax, withholding tax Qatar, capital gains tax, tax exemptions, Dhareiba, tax residency, permanent establishment Qatar, retention, tax penalties',
    },
    '/laws/qatar/tax-procedures-law': {
      title: 'Qatar Tax Procedures Law | Assessments, Objections, Appeals',
      description:
        'Search official Qatar Tax Procedures Law text with article-level navigation. Coverage includes tax obligations, assessments, objections, appeals, and penalties.',
      keywords:
        'Qatar Tax Procedures Law, tax assessment Qatar, tax objection, tax appeal, GTA procedures, tax obligations, penalties, limitation period, tax audit, dispute resolution',
    },
    '/laws/qatar/excise-law-25-of-2018': {
      title: 'Qatar Excise Law 2018 | Taxable Goods, Rates, Returns',
      description:
        'Official Qatar Excise Law 2018 parsed and structured: taxable goods, rates, tax stamps, registration, returns, and transitional rules with article-level navigation.',
      keywords:
        'Qatar Excise Law 2018, Law No. 25 of 2018, excise tax Qatar, selective tax, carbonated drinks, energy drinks, tobacco, special purpose goods, excise returns, tax suspension, penalties',
    },
    '/laws/qatar/dmtt-fdl-22-of-2024': {
      title:
        'Qatar Domestic Minimum Top-up Tax (DMTT) | Law, Decisions, Guides',
      description:
        'Search Qatar DMTT law (FDL No 22 of 2024) and decisions with article-level navigation, updates, and practical guides: Pillar Two, top-up tax, and compliance.',
      keywords:
        'Qatar Tax, Qatar DMTT, Domestic Minimum Top-up Tax, FDL No 22 of 2024, Pillar Two, Global Minimum Tax, OECD Pillar Two Qatar, Top-up Tax Calculation, Multinational Enterprises, MNEs, Tax Compliance Qatar, Income Tax Law Qatar, GTA Qatar',
    },
    '/laws/qatar/fatca-of-2014-iga-m1': {
      title: 'Qatar FATCA Regulations | US Tax Compliance & Reporting',
      description:
        'Official Qatar FATCA guidance and regulations. Compliance procedures for financial institutions, due diligence, reporting standards, and US tax interaction.',
      keywords:
        'Qatar FATCA, Foreign Account Tax Compliance Act, US tax compliance Qatar, financial institutions reporting, due diligence, IRS reporting, intergovernmental agreement, GTA guidance',
    },
    '/laws/oman/income-tax-law-royal-decree-28-of-2009': {
      title: 'Oman Income Tax Law 2009 | Royal Decree 28/2009',
      description:
        'Search Oman Income Tax Law 2009 (Royal Decree 28/2009) with article-level navigation: corporate tax rates, withholding, exemptions, and dispute resolution.',
      keywords:
        'Income Tax Law 2009, Royal Decree 28 of 2009, corporate tax Oman, withholding tax Oman, permanent establishment Oman, tax exemptions, dispute resolution, tax card, returns and assessment, penalties',
    },
    '/laws/oman/vat-law-royal-decree-121-of-2020': {
      title: 'Oman VAT Law | Royal Decree No. 121 of 2020',
      description:
        'Official Oman VAT Law - Royal Decree No. 121 of 2020 parsed and structured. Coverage includes registration, zero-rating, exemptions, returns and penalties.',
      keywords:
        'VAT Law Royal Decree 121 of 2020, Oman VAT, tax invoice, input tax deduction, VAT return Oman, zero rated supplies, exempt supplies, reverse charge Oman, responsible person, VAT refunds',
    },
    '/laws/oman/excise-tax-law-royal-decree-23-of-2019': {
      title: 'Oman Excise Law of 2019 | Royal Decree 23/2019',
      description:
        'Official Oman Excise Tax Law (Royal Decree 23/2019) parsed and structured. Coverage includes taxable goods, rates, tax stamps, returns, and penalties.',
      keywords:
        'Oman Excise Law of 2019, Royal Decree 23/2019, excise tax Oman, selective tax, taxable goods, energy drinks, tobacco, pork, excise returns, digital tax stamps, penalties',
    },
    '/laws/oman/cbcr-law': {
      title: 'Oman CbCR Law | Country-by-Country Reporting Rules',
      description:
        'Search Oman Country-by-Country Reporting (CbCR) regulations. MNE notification requirements, filing deadlines, aggregate data reporting, and penalties.',
      keywords:
        'Oman CbCR Law, Country-by-Country Reporting, MNE reporting Oman, transfer pricing documentation, BEPS Action 13, CbC notification, filing requirements, penalties, Tax Authority Decision 79/2020',
    },
    '/laws/oman/fatca-of-2014-direct': {
      title: 'Oman FATCA Regulations | US Compliance & Reporting',
      description:
        'Official Oman FATCA guidance and regulations. Compliance procedures for financial institutions, due diligence, reporting standards, and US tax interaction.',
      keywords:
        'Oman FATCA, Foreign Account Tax Compliance Act, US tax compliance Oman, financial institutions reporting, due diligence, IRS reporting, intergovernmental agreement',
    },
    '/laws/bahrain/dmtt-law-11-of-2024': {
      title: 'Bahrain DMTT Law (Decree Law No. 11 of 2024) | Pillar Two',
      description:
        'Authoritative Bahrain DMTT Law (Decree Law No. 11 of 2024): scope, MNE obligations, computation, top-up tax filing steps and NBR guidance.',
      keywords:
        'Bahrain QDMTT Law, Decree Law 11 of 2024, Pillar Two Bahrain, MNE tax Bahrain, top-up tax, GloBE rules Bahrain, NBR guidance, safe harbours, effective tax rate, multinational enterprises',
    },
    '/laws/bahrain/vat-law-48-of-2018': {
      title: 'Bahrain VAT Law 48 of 2018 | Invoicing, Returns, Refunds',
      description:
        'Search Bahrain VAT Law 48 of 2018 and regulations with article-level navigation: registration, place of supply, zero-rating, refunds and penalties.',
      keywords:
        'Bahrain VAT Law 48 of 2018, NBR VAT, VAT registration Bahrain, tax invoice, basic rate, zero rate, VAT return Bahrain, penalties, input tax recovery, reverse charge Bahrain',
    },
  },
  'uaetaxlaws.com': {
    '/': {
      title: 'UAE Tax Laws | VAT, CIT, DMTT, Customs, Excise, FATCA, CRS',
      description:
        'Official UAE tax texts, parsed and structured: VAT, Corporate Tax (CIT), customs, excise, FATCA/CRS and DMTT (Pillar Two) with article-level navigation and updates.',
      keywords:
        'UAE VAT, UAE Corporate Tax, CIT 9%, customs UAE, excise UAE, FATCA UAE, CRS UAE, DMTT UAE, Pillar Two UAE, top-up tax, QDMTT, GloBE, FTA decisions, executive regulations',
      h1: 'Your go-to tax research platform',
      h2: 'Authoritative UAE tax laws and treaty research',
      h3: 'VAT: law, regulations, returns, invoicing, refunds\n\nCorporate Tax (CIT): scope, filings, reliefs\n\nDMTT (Pillar Two): scope, computation, filings\n\nCustoms: duties, exemptions, procedures\n\nExcise: categories, rates, DTS\n\nFATCA & CRS: registration, due diligence, reporting\n\nArticle-level search, filters and update history',
    },
    '/about-us': {
      title: 'About uaetaxlaws.com | UAE tax law research',
      description:
        'We publish UAE tax texts from official sources, parsed and structured: VAT, Corporate Tax, Tax Procedures, customs, excise, FATCA/CRS and DMTT (Pillar Two).',
      keywords:
        'UAE tax research, UAE tax database, official texts, VAT UAE, Corporate Tax UAE, Tax Procedures Law, customs UAE, excise UAE, FATCA UAE, CRS UAE, DMTT UAE, Pillar Two UAE, article-level navigation, update history',
    },
    '/partner-with-us': {
      title: 'Partner with UAEtaxlaws.com | Data licensing and APIs',
      description:
        'License UAE tax law content built from official texts. Embed via API, enable SSO and bulk access, co-brand training, and power your research tools.',
      keywords:
        'data licensing, API, SSO, bulk seats, site license, white label, content embedding, tax treaty data, transfer pricing data, enterprise integration, co-branded training',
    },
    '/contact-us': {
      title: 'Contact UAEtaxlaws.com | Support, Licensing & API',
      description:
        'Reach UAEtaxlaws.com for support, sales and partnerships. Ask about licensing, API feeds, and structured UAE tax texts on VAT, Corporate Tax, and treaties.',
      keywords:
        'support, sales, licensing, API, site license, bulk seats, SSO, SCIM, enterprise, data syndication, correction request, partnerships, media',
    },
    '/features': {
      title: 'Features | UAE Tax Laws Research Tools',
      description:
        'Official UAE tax texts, parsed and structured with article-level navigation, powerful search, filters, cross-references, and update history across VAT, CIT, Zakat, customs, excise, treaties.',
      keywords:
        'official texts, structured articles, article-level navigation, search filters, cross-references, update history, UAE VAT, UAE corporate tax, Saudi VAT, Zakat, customs, excise, treaties',
      h1: 'UAE Tax Features',
      h2: 'Built from official UAE texts, structured for fast, reliable research. UAETaxLaws.com parses and organizes UAE tax sources into an article-level experience with jump links, cross-references across laws and treaties, and fast search with smart filters,backed by update tracking and clear release notes so you can see what changed and when.',
    },
    '/pricing': {
      title: 'UAE Tax Laws Pricing | Individual, Team, Firm, Enterprise',
      description:
        'Unlock structured UAE tax texts: tax treaty, VAT, corporate tax, Zakat, customs, excise, and treaties. Team and enterprise licenses with options for API and SSO.',
      keywords:
        'enterprise access, team access, role-based seats, content exports, saved views, API, SSO, IP control, procurement, quote, VAT, CIT, Zakat, customs, excise, DTAA',
      h1: 'Pricing, plans & subscriptions',
      h2: 'Get complete access to UAE tax laws and all UAE tax treaties (as and when made available on the portal)',
    },
    '/search-across-law': {
      title: 'Search UAE Laws & Treaties | VAT, Corporate Tax, Zakat',
      description:
        'Select a jurisdiction and tax law to search structured UAE tax texts. Article-level navigation, filters, cross-references for UAE, Saudi, KSA Qatar, Bahrain, Kuwait, Oman.',
      keywords:
        'UAE tax search, UAE VAT search, UAE corporate tax search, Saudi VAT search, Zakat, customs, excise, treaties, article-level, filters, cross-references, treaty search, DTAA search',
    },
    '/blogs': {
      title: 'GCC Tax Blog | Treaties, VAT, Corporate Tax, Transfer Pricing',
      description:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
      keywords:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
    },
    '/news/uae': {
      title: 'UAE Tax News | FTA Announcements & Regulatory Updates',
      description:
        'Latest UAE tax news and Federal Tax Authority (FTA) announcements. VAT, Corporate Tax (CIT), DMTT, excise and customs updates from official UAE tax authority sources.',
      keywords:
        'UAE tax news, FTA news, Federal Tax Authority announcements, UAE VAT news, UAE Corporate Tax news, CIT UAE updates, UAE DMTT news, Pillar Two UAE, excise UAE updates, UAE tax regulatory updates, UAE tax alerts',
    },
    '/search/UAE/Tax-Treaties': {
      title: 'UAE Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Search official text of UAE tax treaties by partner country. Article level pages, filters, and official texts covering withholding, PE, capital gains, and relief.',
      keywords:
        'UAE tax treaties, UAE DTT, UAE DTAA, double taxation agreements UAE, treaty list UAE, withholding tax UAE treaty, PE UAE treaty, capital gains article 13 UAE, residency tie-breaker, tax credit article 23, dividends interest royalties UAE, PE, Permanent Establishment, Profit attribution',
    },
    '/laws/GCC/common-customs-agreement': {
      title: 'GCC Common Customs Agreement | Customs union rules & procedures',
      description:
        'Official GCC Common Customs Agreement, parsed and structured: scope, valuation, classification, duty rates, exemptions, origin, transit, warehousing, procedures, penalties, appeals.',
      keywords:
        'GCC Common Customs Agreement, GCC customs union, customs valuation, tariff classification, duty rates, exemptions, rules of origin, transit, warehousing, customs procedures, penalties, appeals',
    },
    '/laws/GCC/common-vat-agreement': {
      title: 'GCC Common VAT Agreement | Unified VAT framework',
      description:
        'Unified GCC VAT framework parsed and structured: scope, place of supply, rates and exemptions, registration, reverse charge, intra GCC trade, refunds and compliance.',
      keywords:
        'GCC Common VAT Agreement, Unified VAT Agreement for the GCC, GCC VAT, place of supply, zero rated supplies, exemptions, VAT registration, VAT groups, reverse charge, intra GCC supplies, imports and exports, input tax refunds, invoicing and records, penalties and disputes',
    },
    '/laws/GCC/common-excise-agreement': {
      title: 'GCC Common Excise Agreement | Selective tax framework',
      description:
        'Unified GCC excise framework: taxable goods and rates, registration, warehouses & suspension, declarations & payment, tax stamps, penalties and refunds.',
      keywords:
        'GCC Common Excise Agreement, GCC excise tax, selective tax GCC, taxable goods, excise rates, registration and licensing, excise warehouse, suspension arrangement, declarations, payment, tax stamps, digital tax stamps, track and trace, offences and penalties, refunds, exemptions, imports and exports, coordination with customs',
    },
    '/laws/uae/cit-fdl-47-of-2022': {
      title: 'UAE Corporate Tax (CIT) | Law, Decisions, Guides',
      description:
        'Search UAE Corporate Tax law and decisions with article-level navigation, updates, and practical guides: registration, filing, free-zone rules, TP, reliefs.',
      keywords:
        'UAE Tax, UAE Corporate Tax, CIT UAE 9%, Federal Decree-Law 47/2022, Cabinet Decisions, Ministerial Decisions, Qualifying Free Zone Person, QFZP, Qualifying Income, Small Business Relief, TP UAE, Master file, Local file, CbCR, Interest deduction limitation, Participation exemption, Foreign tax credit, Tax groups, Loss relief, Business restructuring, Registration, Filing, DMTT, Pillar two UAE',
    },
    '/laws/uae/dmtt-fdl-60-of-2023': {
      title: 'UAE DMTT (FDL No 60 of 2023) | Law, Decisions, Guides',
      description:
        'Search UAE Global Minimum Tax (DMTT/Pillar Two) law and decisions with article-level navigation, updates, and practical guides: MNE scope, top-up tax calculation, safe harbours, and filings.',
      keywords:
        'UAE DMTT, Federal Decree-Law 60 of 2023, Global Minimum Tax UAE, Pillar Two, Top-up Tax, MNE Groups, GloBE Rules, QDMTT, Multinational Enterprises, 15% effective tax rate',
    },
    '/laws/uae/indirecttax-law-vat-uaevat-8-of-2017-as-amended': {
      title: 'UAE VAT | Law, Decisions, Guide, Returns, Invoicing',
      description:
        'Official UAE VAT texts parsed and structured: law, regulations, decisions, guides and public clarifications. Coverage includes registration, returns, invoicing and refunds.',
      keywords:
        'UAE VAT, VAT UAE guidance, executive regulations, FTA public clarifications, registration threshold, VAT returns UAE, tax invoices, credit notes, input tax recovery, refund procedures, penalties UAE VAT, reverse charge UAE, zero rate, exemption',
    },
    '/laws/uae/tp-fdl-28-of-2022-as-amended': {
      title: 'UAE Tax Procedures | Law, Executive Regulation',
      description:
        'Search UAE Tax Procedures with article-level navigation: assessments, audits, penalties, voluntary disclosure, reconsideration, objections, appeals, and time limits.',
      keywords:
        'UAE Tax Procedures Law, Executive Regulation, FTA, assessments, tax audit, voluntary disclosure, administrative penalties, reconsideration, objection, appeal, time limits, limitation period, record keeping, information requests, payment, refunds, guarantees, enforcement',
    },
    '/laws/uae/indirect-excise-7-of-2017-as-amended': {
      title: 'UAE Excise Tax Law | Decree-Law 7 of 2017 | Rates & Goods',
      description:
        'Search Federal Decree-Law No. 7 of 2017 on Excise Tax. Article-level navigation for taxable goods, rates, registration, tax liability, stockpiling, and penalties.',
      keywords:
        'UAE Excise Law, Federal Decree-Law 7 of 2017, excise tax rates, tobacco tax, energy drinks, carbonated drinks, sweetened beverages, excise registration, tax warehouse, digital tax stamps, DTS',
    },
    '/laws/uae/fatca-of-2024': {
      title: 'UAE FATCA Compliance 2024 | Regulations & Reporting Guidelines',
      description:
        'Authoritative UAE FATCA reporting hub for 2024. Access official guidance, IGA text, due diligence rules, and submission procedures for Financial Institutions.',
      keywords:
        'UAE FATCA 2024, Foreign Account Tax Compliance Act, MoF FATCA guidance, Regulatory Authorities, IGA Model 1, CRS FATCA portal, US indicia, financial institution reporting, due diligence',
    },
    '/laws/uae/crs-federal-decree-48-of-2018': {
      title: 'UAE Common Reporting Standard (CRS) | Regulations & Guidance',
      description:
        'Comprehensive guide to UAE CRS regulations. Access Federal Decree-Laws, Cabinet Decisions, and guidance for Financial Institutions on due diligence and reporting.',
      keywords:
        'UAE CRS, Common Reporting Standard UAE, Automatic Exchange of Information, AEOI UAE, FATCA CRS UAE, UAE Portal, Financial Institutions, Reportable Accounts, Due Diligence, CRS Guidance Notes, CRS Compliance, Reporting Financial Institution, Non-Reporting Financial Institution, UAE Ministry of Finance CRS',
    },
  },
  'ksataxlaws.com': {
    '/': {
      title:
        'Saudi (ksa) Tax Laws | VAT, CIT, DMTT, Customs, Excise, FATCA, CRS',
      description:
        'Official Saudi (ksa) tax texts, parsed and structured: VAT, Corporate Tax (CIT), customs, excise, FATCA/CRS and DMTT (Pillar Two) with article-level navigation and updates.',
      keywords:
        'Saudi (ksa) VAT, Saudi (ksa) Corporate Tax, CIT 9%, customs Saudi (ksa), excise Saudi (ksa), FATCA Saudi (ksa), CRS Saudi (ksa), DMTT Saudi (ksa), Pillar Two Saudi (ksa), top-up tax, QDMTT, GloBE, FTA decisions, executive regulations',
      h1: 'Your go-to tax research platform',
      h2: 'Authoritative KSA tax laws and treaty research',
      h3: 'VAT: law, regulations, returns, invoicing, refunds\n\nCorporate Tax (CIT): scope, filings, reliefs\n\nDMTT (Pillar Two): scope, computation, filings\n\nCustoms: duties, exemptions, procedures\n\nExcise: categories, rates, DTS\n\nFATCA & CRS: registration, due diligence, reporting\n\nArticle-level search, filters and update history',
    },
    '/about-us': {
      title: 'About ksataxlaws.com | ksa tax law research',
      description:
        'We publish ksa tax texts from official sources, parsed and structured: VAT, Corporate Tax, Tax Procedures, customs, excise, FATCA/CRS and DMTT (Pillar Two).',
      keywords:
        'ksa tax research, ksa tax database, official texts, VAT ksa, Corporate Tax ksa, Tax Procedures Law, customs ksa, excise ksa, FATCA ksa, CRS ksa, DMTT ksa, Pillar Two ksa, article-level navigation, update history',
    },
    '/partner-with-us': {
      title: 'Partner with ksataxlaws.com | Data licensing and APIs',
      description:
        'License ksa tax law content built from official texts. Embed via API, enable SSO and bulk access, co-brand training, and power your research tools.',
      keywords:
        'data licensing, API, SSO, bulk seats, site license, white label, content embedding, tax treaty data, transfer pricing data, enterprise integration, co-branded training',
    },
    '/contact-us': {
      title: 'Contact ksataxlaws.com | Support, Licensing & API',
      description:
        'Reach ksataxlaws.com for support, sales and partnerships. Ask about licensing, API feeds, and structured ksa tax texts on VAT, Corporate Tax, and treaties.',
      keywords:
        'support, sales, licensing, API, site license, bulk seats, SSO, SCIM, enterprise, data syndication, correction request, partnerships, media',
    },
    '/features': {
      title: 'Features | ksa Tax Laws Research Tools',
      description:
        'Official ksa tax texts, parsed and structured with article-level navigation, powerful search, filters, cross-references, and update history across VAT, CIT, Zakat, customs, excise, treaties.',
      keywords:
        'official texts, structured articles, article-level navigation, search filters, cross-references, update history, ksa VAT, ksa corporate tax, Saudi VAT, Zakat, customs, excise, treaties',
      h1: 'KSA Tax Features',
      h2: 'Built from official Saudi Arabia texts, structured for fast, reliable research. KSATaxLaws.com parses and organizes Saudi Arabia tax sources into an article-level experience with jump links, cross-references across laws and treaties, and fast search with smart filters, backed by update tracking and clear release notes so you can see what changed and when.',
    },
    '/pricing': {
      title: 'ksa Tax Laws Pricing | Individual, Team, Firm, Enterprise',
      description:
        'Unlock structured ksa tax texts: tax treaty, VAT, corporate tax, Zakat, customs, excise, and treaties. Team and enterprise licenses with options for API and SSO.',
      keywords:
        'enterprise access, team access, role-based seats, content exports, saved views, API, SSO, IP control, procurement, quote, VAT, CIT, Zakat, customs, excise, DTAA',
      h1: 'Pricing, plans & subscriptions',
      h2: 'Get complete access to KSA tax laws and all KSA tax treaties (as and when made available on the portal)',
    },
    '/search-across-law': {
      title: 'Search Saudi (ksa) Laws & Treaties | VAT, Corporate Tax, Zakat',
      description:
        'Select a jurisdiction and tax law to search structured ksa tax texts. Article-level navigation, filters, cross-references for ksa, Saudi, KSA Qatar, Bahrain, Kuwait, Oman.',
      keywords:
        'ksa tax search, ksa VAT search, ksa corporate tax search, Saudi VAT search, Zakat, customs, excise, treaties, article-level, filters, cross-references, treaty search, DTAA search',
    },
    '/blogs': {
      title: 'GCC Tax Blog | Treaties, VAT, Corporate Tax, Transfer Pricing',
      description:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
      keywords:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
    },
    '/news/ksa': {
      title: 'Saudi (KSA) Tax News | ZATCA Announcements & Updates',
      description:
        'Latest Saudi Arabia (KSA) tax news and ZATCA announcements. VAT, Corporate Income Tax, Zakat, e-invoicing, excise and customs updates from ZATCA official sources.',
      keywords:
        'Saudi tax news, KSA tax news, ZATCA news, ZATCA announcements, Saudi VAT news, Saudi corporate tax news, Zakat news, e-invoicing Saudi, KSA excise updates, Saudi tax regulatory updates',
    },
    '/search/KSA/Tax-Treaties': {
      title: 'Saudi (ksa) Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Search official text of Saudi (ksa) tax treaties by partner country. Article level pages, filters, and official texts covering withholding, PE, capital gains, and relief.',
      keywords:
        'ksa tax treaties, ksa DTT, ksa DTAA, double taxation agreements ksa, treaty list ksa, withholding tax ksa treaty, PE ksa treaty, capital gains article 13 ksa, residency tie-breaker, tax credit article 23, dividends interest royalties ksa, PE, Permanent Establishment, Profit attribution',
    },
    '/laws/GCC/common-customs-agreement': {
      title: 'GCC Common Customs Agreement | Customs union rules & procedures',
      description:
        'Official GCC Common Customs Agreement, parsed and structured: scope, valuation, classification, duty rates, exemptions, origin, transit, warehousing, procedures, penalties, appeals.',
      keywords:
        'GCC Common Customs Agreement, GCC customs union, customs valuation, tariff classification, duty rates, exemptions, rules of origin, transit, warehousing, customs procedures, penalties, appeals',
    },
    '/laws/GCC/common-vat-agreement': {
      title: 'GCC Common VAT Agreement | Unified VAT framework',
      description:
        'Unified GCC VAT framework parsed and structured: scope, place of supply, rates and exemptions, registration, reverse charge, intra GCC trade, refunds and compliance.',
      keywords:
        'GCC Common VAT Agreement, Unified VAT Agreement for the GCC, GCC VAT, place of supply, zero rated supplies, exemptions, VAT registration, VAT groups, reverse charge, intra GCC supplies, imports and exports, input tax refunds, invoicing and records, penalties and disputes',
    },
    '/laws/GCC/common-excise-agreement': {
      title: 'GCC Common Excise Agreement | Selective tax framework',
      description:
        'Unified GCC excise framework: taxable goods and rates, registration, warehouses & suspension, declarations & payment, tax stamps, penalties and refunds.',
      keywords:
        'GCC Common Excise Agreement, GCC excise tax, selective tax GCC, taxable goods, excise rates, registration and licensing, excise warehouse, suspension arrangement, declarations, payment, tax stamps, digital tax stamps, track and trace, offences and penalties, refunds, exemptions, imports and exports, coordination with customs',
    },
    '/laws/ksa/income-tax-law-of-2004': {
      title:
        'Saudi (KSA) Corporate Income Tax | Law, TP, Withholding, Guidance',
      description:
        'Search Saudi (KSA) corporate income tax law and regulations with article-level navigation, updates and guides: registration, returns, withholding, PE and transfer pricing.',
      keywords:
        'Saudi Tax, KSA Corporate Income Tax, Saudi CIT, ZATCA, Income Tax Law 2004, Implementing Regulations, withholding tax KSA, permanent establishment KSA, non-resident taxation, transfer pricing bylaws, master file, local file, CbCR, deductibility rules, loss carryforward, returns and payments, objections and appeals, DMTT, Pillar two Saudi (KSA)',
    },
    '/laws/ksa/vat-law-m-113-of-2017': {
      title: 'Saudi (KSA) VAT | Registration, Returns, Refunds, E-invoicing',
      description:
        'Official Saudi VAT texts parsed and structured. Coverage includes registration, return filing, e-invoicing, input tax refunds, penalties and dispute steps.',
      keywords:
        'Saudi VAT, KSA VAT, ZATCA, Implementing Regulations, e-invoicing FATOORA, registration, returns, payments, refunds, input tax, zero rated, exempt supplies, reverse charge, imports, penalties, audits, objections, appeals, public decisions, guides',
    },
    '/laws/ksa/excise-law-of-2019': {
      title: 'Saudi (KSA) Excise Tax Law | Rates, Goods, Returns',
      description:
        'Official Saudi Excise Tax Law (Royal Decree M/86) and amendments (including 2019 sweetened beverages). Coverage: taxable goods, rates, tax base, registration, returns and penalties.',
      keywords:
        'Saudi Excise Tax Law, KSA Excise Law, Royal Decree M/86, excise goods KSA, sweetened beverages tax, tobacco tax Saudi, energy drinks tax, tax stamps, excise registration, transitional rules',
    },
    '/laws/ksa/zakat-law-of-1951': {
      title: 'Saudi (KSA) Zakat Law | Decree 17/2/28/8634 of 1951',
      description:
        'Search the foundational Zakat Collection Law (1951) and modern Implementing Regulations. Coverage includes Zakat base calculation, adjusted net profit, deductions, and collection procedures.',
      keywords:
        'Saudi Zakat Law, Zakat Collection Law 1951, Royal Decree 17/2/28/8634, Zakat regulations KSA, Zakat base, adjusted net profit, Zakat 2.5%, legitimate expenses, Zakat collection',
    },
    '/laws/ksa/customs-law': {
      title: 'Saudi (KSA) Customs Law | GCC Common Customs Law',
      description:
        'Official KSA implementation of the Common Customs Law of the GCC States. Rules for import/export, customs valuation, tariff classification, prohibitions, and clearance procedures.',
      keywords:
        'Saudi Customs Law, Common Customs Law of the GCC, KSA customs procedures, customs valuation, tariff classification, harmonized system, customs duties KSA, temporary admission, customs exemptions, bayern',
    },
    '/laws/ksa/fatca-of-2017': {
      title: 'Saudi (KSA) FATCA Regulations | US Tax Compliance',
      description:
        'Official Saudi regulations for FATCA (ratified by Royal Decree M/52 of 2017). Compliance for financial institutions, US reportable accounts, due diligence, and IGA reporting standards.',
      keywords:
        'Saudi FATCA regulations, Royal Decree M/52, US tax compliance KSA, Foreign Account Tax Compliance Act, IGA Saudi USA, financial institutions reporting, due diligence, reportable accounts, TIN requirements',
    },
  },
  'kuwaittaxlaws.com': {
    '/': {
      title:
        'Kuwait Tax Laws | Corporate Income Tax, DMTT, QDMTT< Zakat. Pillar Two',
      description:
        'Official Kuwait tax texts, parsed and structured: Corporate Income Tax, DMTT (Pillar Two), Zakat/NLST/KFAS, contracts 5% retention, customs, treaties, procedures.',
      keywords:
        'Kuwait corporate income tax, income tax decree, executive rules, DMTT Kuwait, QDMTT Kuwait, Pillar Two, Zakat Kuwait, NLST, KFAS, 5% retention, clearance certificate, PE Kuwait, withholding tax Kuwait, contracts compliance, customs Kuwait, treaty list Kuwait, objections and appeals',
      h1: 'Your go-to tax research platform',
      h2: 'Authoritative Kuwait tax laws and treaty research',
      h3: 'Corporate Income Tax (law and executive rules)\n\nDMTT (Pillar Two): scope, computation, filing\n\nZakat, NLST and KFAS contributions\n\nContracts: 5% retention and clearance certificate\n\nNon-resident taxation: PE and withholding\n\nTreaties and double tax relief\n\nProcedures: assessments, objections, appeals\n\nCustoms framework and notices\n\nUpdate history and versions',
    },
    '/about-us': {
      title: 'About kuwaittaxlaws.com | kuwait tax law research',
      description:
        'We publish kuwait tax texts from official sources, parsed and structured: VAT, Corporate Tax, Tax Procedures, customs, excise, FATCA/CRS and DMTT (Pillar Two).',
      keywords:
        'kuwait tax research, kuwait tax database, official texts, VAT kuwait, Corporate Tax kuwait, Tax Procedures Law, customs kuwait, excise kuwait, FATCA kuwait, CRS kuwait, DMTT kuwait, Pillar Two kuwait, article-level navigation, update history',
    },
    '/partner-with-us': {
      title: 'Partner with kuwaittaxlaws.com | Data licensing and APIs',
      description:
        'License kuwait tax law content built from official texts. Embed via API, enable SSO and bulk access, co-brand training, and power your research tools.',
      keywords:
        'data licensing, API, SSO, bulk seats, site license, white label, content embedding, tax treaty data, transfer pricing data, enterprise integration, co-branded training',
    },
    '/contact-us': {
      title: 'Contact kuwaittaxlaws.com | Support, Licensing & API',
      description:
        'Reach kuwaittaxlaws.com for support, sales and partnerships. Ask about licensing, API feeds, and structured kuwait tax texts on VAT, Corporate Tax, and treaties.',
      keywords:
        'support, sales, licensing, API, site license, bulk seats, SSO, SCIM, enterprise, data syndication, correction request, partnerships, media',
    },
    '/features': {
      title: 'Features | kuwait Tax Laws Research Tools',
      description:
        'Official kuwait tax texts, parsed and structured with article-level navigation, powerful search, filters, cross-references, and update history across VAT, CIT, Zakat, customs, excise, treaties.',
      keywords:
        'official texts, structured articles, article-level navigation, search filters, cross-references, update history, kuwait VAT, kuwait corporate tax, Saudi VAT, Zakat, customs, excise, treaties',
      h1: 'Kuwait Tax Features',
      h2: 'Built from official Kuwait texts, structured for fast, reliable research. KuwaitTaxLaws.com parses and organizes Kuwait tax sources into an article-level experience with jump links, cross-references across laws and treaties, and fast search with smart filters, backed by update tracking and clear release notes so you can see what changed and when.',
    },
    '/pricing': {
      title: 'kuwait Tax Laws Pricing | Individual, Team, Firm, Enterprise',
      description:
        'Unlock structured kuwait tax texts: tax treaty, VAT, corporate tax, Zakat, customs, excise, and treaties. Team and enterprise licenses with options for API and SSO.',
      keywords:
        'enterprise access, team access, role-based seats, content exports, saved views, API, SSO, IP control, procurement, quote, VAT, CIT, Zakat, customs, excise, DTAA',
      h1: 'Pricing, plans & subscriptions',
      h2: 'Get complete access to Kuwait tax laws and all Kuwait tax treaties (as and when made available on the portal)',
    },
    '/search-across-law': {
      title: 'Search Kuwait Tax Laws | CIT, DMTT, Zakat, Treaties',
      description:
        'Search article-level Kuwait tax texts: Corporate Income Tax, DMTT, Zakat/NLST/KFAS, 5% retention, tax retention, PE, withholding, customs and treaty relief.',
      keywords:
        'Kuwait CIT, DMTT/QDMTT, Pillar Two Kuwait, Zakat law Kuwait, NLST Kuwait, KFAS levy, retention on payments, clearance workflow, PE rules, WHT categories, treaty network Kuwait, assessments, audits, appeals, customs duty GCC',
    },
    '/blogs': {
      title: 'GCC Tax Blog | Treaties, VAT, Corporate Tax, Transfer Pricing',
      description:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
      keywords:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
    },
    '/news/kuwait': {
      title: 'Kuwait Tax News | Government Announcements & Updates',
      description:
        'Latest Kuwait tax news and Kuwait Government Online announcements. Corporate income tax, DMTT, Zakat/NLST/KFAS, customs and treaty updates from official Kuwait sources.',
      keywords:
        'Kuwait tax news, Kuwait Government Online news, Kuwait DMTT updates, Kuwait Pillar Two news, Kuwait corporate tax news, NLST Kuwait, KFAS Kuwait, Zakat Kuwait news, Kuwait customs updates, Kuwait tax regulatory alerts',
    },
    '/search/Kuwait/Tax-Treaties': {
      title: 'kuwait Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Search official text of kuwait tax treaties by partner country. Article level pages, filters, and official texts covering withholding, PE, capital gains, and relief.',
      keywords:
        'kuwait tax treaties, kuwait DTT, kuwait DTAA, double taxation agreements kuwait, treaty list kuwait, withholding tax kuwait treaty, PE kuwait treaty, capital gains article 13 kuwait, residency tie-breaker, tax credit article 23, dividends interest royalties kuwait, PE, Permanent Establishment, Profit attribution',
    },
    '/laws/GCC/common-customs-agreement': {
      title: 'GCC Common Customs Agreement | Customs union rules & procedures',
      description:
        'Official GCC Common Customs Agreement, parsed and structured: scope, valuation, classification, duty rates, exemptions, origin, transit, warehousing, procedures, penalties, appeals.',
      keywords:
        'GCC Common Customs Agreement, GCC customs union, customs valuation, tariff classification, duty rates, exemptions, rules of origin, transit, warehousing, customs procedures, penalties, appeals',
    },
    '/laws/GCC/common-vat-agreement': {
      title: 'GCC Common VAT Agreement | Unified VAT framework',
      description:
        'Unified GCC VAT framework parsed and structured: scope, place of supply, rates and exemptions, registration, reverse charge, intra GCC trade, refunds and compliance.',
      keywords:
        'GCC Common VAT Agreement, Unified VAT Agreement for the GCC, GCC VAT, place of supply, zero rated supplies, exemptions, VAT registration, VAT groups, reverse charge, intra GCC supplies, imports and exports, input tax refunds, invoicing and records, penalties and disputes',
    },
    '/laws/GCC/common-excise-agreement': {
      title: 'GCC Common Excise Agreement | Selective tax framework',
      description:
        'Unified GCC excise framework: taxable goods and rates, registration, warehouses & suspension, declarations & payment, tax stamps, penalties and refunds.',
      keywords:
        'GCC Common Excise Agreement, GCC excise tax, selective tax GCC, taxable goods, excise rates, registration and licensing, excise warehouse, suspension arrangement, declarations, payment, tax stamps, digital tax stamps, track and trace, offences and penalties, refunds, exemptions, imports and exports, coordination with customs',
    },
    '/laws/kuwait/kit-law-no-2-of-2008-amending-decree-no-3-of-1955': {
      title: 'Kuwait Corporate Income Tax | Law, Rules, Returns',
      description:
        'Search Kuwait corporate income tax law and executive rules with article-level navigation: registration, returns, payments, tax retention and clearance, PE, treaties.',
      keywords:
        'Kuwait Tax, Kuwait corporate income tax, Kuwait income tax decree, executive rules, tax registration Kuwait, tax return Kuwait, tax retention, tax retention 5% Kuwait, tax clearance certificate, permanent establishment Kuwait, non-resident taxation Kuwait, Kuwait tax treaties, objections and appeals, Retention Release Letter, No Objection Letter, Tax Clearance Certificate, TCC',
    },
    '/laws/kuwait/qdmtt-decree-law-157-of-2024': {
      title: 'Kuwait DMTT (QDMTT) | Pillar Two Top-Up Tax',
      description:
        'Authoritative Kuwait QDMTT hub: article-level law, scope, computation, safe harbours, filing and payment steps, and links to official guidance and updates.',
      keywords:
        'Kuwait DMTT, Kuwait QDMTT, Pillar Two Kuwait, domestic minimum top-up tax, top-up tax Kuwait, GloBE Kuwait, safe harbour, returns and payments, penalties, interaction with Kuwait income tax, treaty relief',
    },
    '/laws/kuwait/draft-business-profit-tax-law-of-2024': {
      title: 'Kuwait Draft Business Profits Tax Law 2024 | 15% CIT Proposal',
      description:
        'Overview of the Draft Business Profits Tax Law (BPT) in Kuwait: proposed 15% corporate tax rate, scope for local and foreign companies, exemptions for small businesses, and implementation timeline.',
      keywords:
        'Kuwait Draft Business Profits Tax Law, Kuwait BPT 2024, proposed corporate tax Kuwait 15%, Kuwait corporate income tax draft, Pillar Two Kuwait, withholding tax Kuwait draft, tax exemptions small business Kuwait',
    },
  },
  'qatartaxlaws.com': {
    '/': {
      title: 'Qatar Tax Laws | Income Tax, Excise, Tax Procedures, FATCA',
      description:
        'Official Qatar tax texts, parsed and structured: Income Tax Law 24 of 2018, Tax Procedures Law, Excise Law 2018, and FATCA regulations with article-level navigation.',
      keywords:
        'Qatar Income Tax Law 24 of 2018, Tax Procedures Law Qatar, Excise Law 2018 Qatar, FATCA Qatar, GTA Qatar, Dhareiba, corporate tax Qatar, withholding tax Qatar, retention',
      h1: 'Your go-to tax research platform',
      h2: 'Authoritative Qatar tax laws and treaty research',
      h3: 'Income Tax: Law 24 of 2018, regulations, withholding\n\nTax Procedures: Assessment, objections, appeals\n\nExcise: Law 25 of 2018, goods, returns\n\nFATCA: Compliance and reporting\n\nCustoms: GCC framework and local rules\n\nTreaties: relief and withholding rates',
    },
    '/about-us': {
      title: 'About qatartaxlaws.com | Qatar tax law research',
      description:
        'We publish Qatar tax texts from official sources, parsed and structured: Income Tax Law 24 of 2018, Tax Procedures, Excise Law 2018, and FATCA with update tracking.',
      keywords:
        'Qatar tax research, Qatar tax database, official texts, Income Tax Law 24 of 2018, Tax Procedures Law, Excise Law 2018, FATCA Qatar, article-level navigation, update history',
    },
    '/partner-with-us': {
      title: 'Partner with qatartaxlaws.com | Data licensing and APIs',
      description:
        'License Qatar tax law content built from official texts. Embed via API, enable SSO and bulk access, co-brand training, and power your research tools.',
      keywords:
        'data licensing, API, SSO, bulk seats, site license, white label, content embedding, tax treaty data, transfer pricing data, enterprise integration, co-branded training',
    },
    '/contact-us': {
      title: 'Contact qatartaxlaws.com | Support, Licensing & API',
      description:
        'Reach qatartaxlaws.com for support, sales and partnerships. Ask about licensing, API feeds, and structured Qatar tax texts on Income Tax, Excise, and Tax Procedures.',
      keywords:
        'support, sales, licensing, API, site license, bulk seats, SSO, SCIM, enterprise, data syndication, correction request, partnerships, media',
    },
    '/features': {
      title: 'Features | Qatar Tax Laws Research Tools',
      description:
        'Official Qatar tax texts, parsed and structured with article-level navigation, powerful search, filters, cross-references across Income Tax, Excise, Tax Procedures, and FATCA.',
      keywords:
        'official texts, structured articles, article-level navigation, search filters, cross-references, update history, Qatar Income Tax Law 24 of 2018, Excise Law 2018, Tax Procedures Law, FATCA',
      h1: 'Qatar Tax Features',
      h2: 'Built from official Qatar texts, structured for fast, reliable research. QatarTaxLaws.com parses and organizes Qatar tax sources into an article-level experience with jump links, cross-references across laws and treaties, and fast search with smart filters, backed by update tracking and clear release notes so you can see what changed and when.',
    },
    '/pricing': {
      title: 'Qatar Tax Laws Pricing | Individual, Team, Firm, Enterprise',
      description:
        'Unlock structured Qatar tax texts: Income Tax Law 24 of 2018, Tax Procedures, Excise Law 2018, FATCA, and treaties. Team and enterprise licenses with API options.',
      keywords:
        'enterprise access, team access, role-based seats, content exports, saved views, API, SSO, IP control, procurement, quote, Income Tax, Excise, Tax Procedures, DTAA',
      h1: 'Pricing, plans & subscriptions',
      h2: 'Get complete access to Qatar tax laws and all Qatar tax treaties (as and when made available on the portal)',
    },
    '/search-across-law': {
      title: 'Search Qatar Laws & Treaties | Income Tax, Excise, Procedures',
      description:
        'Select a jurisdiction and tax law to search structured Qatar tax texts. Article-level navigation for Income Tax Law 24 of 2018, Tax Procedures, Excise, FATCA.',
      keywords:
        'Qatar tax search, Qatar Income Tax search, Tax Procedures search, Excise search, FATCA search, article-level, filters, cross-references, treaty search, DTAA search',
    },
    '/blogs': {
      title: 'GCC Tax Blog | Treaties, VAT, Corporate Tax, Transfer Pricing',
      description:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
      keywords:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
    },
    '/news/qatar': {
      title: 'Qatar Tax News | General Tax Authority (GTA) Updates',
      description:
        'Latest Qatar tax news and General Tax Authority (GTA) announcements. Income tax, DMTT, excise tax and customs updates from official Qatar tax authority sources.',
      keywords:
        'Qatar tax news, GTA news, General Tax Authority Qatar, Qatar income tax news, Qatar DMTT updates, Pillar Two Qatar, Qatar excise news, Qatar customs updates, Qatar tax regulatory alerts, Qatar tax announcements',
    },
    '/search/Qatar/Tax-Treaties': {
      title: 'Qatar Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Explore official text of Qatar’s double taxation treaties by partner country. Article-level pages with filters and official texts for WHT, PE, capital gains, and relief.',
      keywords:
        'Qatar tax treaties, Qatar DTT, Qatar DTAA, double taxation agreements Qatar, treaty list Qatar, withholding tax Qatar treaty, PE Qatar treaty, capital gains article 13 Qatar, residency tie-breaker, tax credit article 23',
    },
    '/laws/GCC/common-customs-agreement': {
      title: 'GCC Common Customs Agreement | Customs union rules & procedures',
      description:
        'Official GCC Common Customs Agreement, parsed and structured: scope, valuation, classification, duty rates, exemptions, origin, transit, warehousing, procedures, penalties, appeals.',
      keywords:
        'GCC Common Customs Agreement, GCC customs union, customs valuation, tariff classification, duty rates, exemptions, rules of origin, transit, warehousing, customs procedures, penalties, appeals',
    },
    '/laws/GCC/common-vat-agreement': {
      title: 'GCC Common VAT Agreement | Unified VAT framework',
      description:
        'Unified GCC VAT framework parsed and structured: scope, place of supply, rates and exemptions, registration, reverse charge, intra GCC trade, refunds and compliance.',
      keywords:
        'GCC Common VAT Agreement, Unified VAT Agreement for the GCC, GCC VAT, place of supply, zero rated supplies, exemptions, VAT registration, VAT groups, reverse charge, intra GCC supplies, imports and exports, input tax refunds, invoicing and records, penalties and disputes',
    },
    '/laws/GCC/common-excise-agreement': {
      title: 'GCC Common Excise Agreement | Selective tax framework',
      description:
        'Unified GCC excise framework: taxable goods and rates, registration, warehouses & suspension, declarations & payment, tax stamps, penalties and refunds.',
      keywords:
        'GCC Common Excise Agreement, GCC excise tax, selective tax GCC, taxable goods, excise rates, registration and licensing, excise warehouse, suspension arrangement, declarations, payment, tax stamps, digital tax stamps, track and trace, offences and penalties, refunds, exemptions, imports and exports, coordination with customs',
    },
    '/laws/qatar/income-tax-law-24-of-2018': {
      title: 'Income Tax Law 24 of 2018 | Corporate Tax, Withholding',
      description:
        'Search Qatar Income Tax Law 24 of 2018 with article-level navigation: corporate tax rates, withholding, exemptions, penalties and Dhareiba filings.',
      keywords:
        'Income Tax Law 24 of 2018, Qatar corporate tax, withholding tax Qatar, capital gains tax, tax exemptions, Dhareiba, tax residency, permanent establishment Qatar, retention, tax penalties',
    },
    '/laws/qatar/dmtt-fdl-22-of-2024': {
      title:
        'Qatar Domestic Minimum Top-up Tax (DMTT) | Law, Decisions, Guides',
      description:
        'Search Qatar DMTT law (FDL No 22 of 2024) and decisions with article-level navigation, updates, and practical guides: Pillar Two, top-up tax, and compliance.',
      keywords:
        'Qatar Tax, Qatar DMTT, Domestic Minimum Top-up Tax, FDL No 22 of 2024, Pillar Two, Global Minimum Tax, OECD Pillar Two Qatar, Top-up Tax Calculation, Multinational Enterprises, MNEs, Tax Compliance Qatar, Income Tax Law Qatar, GTA Qatar',
    },
    '/laws/qatar/tax-procedures-law': {
      title: 'Qatar Tax Procedures Law | Assessments, Objections, Appeals',
      description:
        'Search official Qatar Tax Procedures Law text with article-level navigation. Coverage includes tax obligations, assessments, objections, appeals, and penalties.',
      keywords:
        'Qatar Tax Procedures Law, tax assessment Qatar, tax objection, tax appeal, GTA procedures, tax obligations, penalties, limitation period, tax audit, dispute resolution',
    },
    '/laws/qatar/excise-law-25-of-2018': {
      title: 'Qatar Excise Law 2018 | Taxable Goods, Rates, Returns',
      description:
        'Official Qatar Excise Law 2018 parsed and structured: taxable goods, rates, tax stamps, registration, returns, and transitional rules with article-level navigation.',
      keywords:
        'Qatar Excise Law 2018, Law No. 25 of 2018, excise tax Qatar, selective tax, carbonated drinks, energy drinks, tobacco, special purpose goods, excise returns, tax suspension, penalties',
    },
    '/laws/qatar/fatca-of-2014-iga-m1': {
      title: 'Qatar FATCA Regulations | US Tax Compliance & Reporting',
      description:
        'Official Qatar FATCA guidance and regulations. Compliance procedures for financial institutions, due diligence, reporting standards, and US tax interaction.',
      keywords:
        'Qatar FATCA, Foreign Account Tax Compliance Act, US tax compliance Qatar, financial institutions reporting, due diligence, IRS reporting, intergovernmental agreement, GTA guidance',
    },
  },
  'omantaxlaws.com': {
    '/': {
      title: 'Oman Tax Laws | VAT, Income Tax, Excise, FATCA, CbCR',
      description:
        'Official Oman tax texts, parsed and structured: VAT Law (Decree 121/2020), Income Tax Law (Royal Decree No 28 of 2009, as amended), Excise Law 2019, FATCA and CbCR.',
      keywords:
        'Oman VAT Law Decree 121 of 2020, Income Tax Law (Royal Decree No 28 of 2009, as amended), Excise Law of 2019, FATCA Oman, CbCR Law Oman, OTA Oman, withholding tax Oman, customs Oman, tax treaties Oman',
      h1: 'Your go-to tax research platform',
      h2: 'Authoritative Oman tax laws and treaty research',
      h3: 'VAT: Decree 121/2020, regulations, returns\n\nIncome Tax: Decree 118/2020, withholding\n\nExcise: Law of 2019, goods, tax stamps\n\nCompliance: FATCA and CbCR Law\n\nCustoms: GCC framework and local rules\n\nTreaties: double tax relief and PE',
    },
    '/about-us': {
      title: 'About omantaxlaws.com | Oman tax law research',
      description:
        'We publish Oman tax texts from official sources, parsed and structured: VAT Law 121/2020, Income Tax Law 118/2020, Excise Law 2019, FATCA and CbCR.',
      keywords:
        'Oman tax research, Oman tax database, official texts, VAT Law Decree 121 of 2020, Income Tax Law (Royal Decree No 28 of 2009, as amended), Excise Law of 2019, FATCA Oman, CbCR Law, OTA Oman, article-level navigation',
    },
    '/partner-with-us': {
      title: 'Partner with omantaxlaws.com | Data licensing and APIs',
      description:
        'License Oman tax law content built from official texts. Embed via API, enable SSO and bulk access, co-brand training, and power your research tools.',
      keywords:
        'data licensing, API, SSO, bulk seats, site license, white label, content embedding, tax treaty data, transfer pricing data, enterprise integration, co-branded training',
    },
    '/contact-us': {
      title: 'Contact omantaxlaws.com | Support, Licensing & API',
      description:
        'Reach omantaxlaws.com for support, sales and partnerships. Ask about licensing, API feeds, and structured Oman tax texts on VAT, Income Tax, and treaties.',
      keywords:
        'support, sales, licensing, API, site license, bulk seats, SSO, SCIM, enterprise, data syndication, correction request, partnerships, media',
    },
    '/features': {
      title: 'Features | Oman Tax Laws Research Tools',
      description:
        'Official Oman tax texts, parsed and structured with article-level navigation, powerful search, filters, cross-references across VAT, Income Tax, Excise, FATCA, CbCR.',
      keywords:
        'official texts, structured articles, article-level navigation, search filters, cross-references, update history, Oman VAT Law, Oman Income Tax Law (Royal Decree No 28 of 2009, as amended), Excise Law 2019, FATCA, CbCR',
      h1: 'Oman Tax Features',
      h2: 'Built from official Oman texts, structured for fast, reliable research. OmanTaxLaws.com parses and organizes Oman tax sources into an article-level experience with jump links, cross-references across laws and treaties, and fast search with smart filters, backed by update tracking and clear release notes so you can see what changed and when.',
    },
    '/pricing': {
      title: 'Oman Tax Laws Pricing | Individual, Team, Firm, Enterprise',
      description:
        'Unlock structured Oman tax texts: tax treaty, VAT, Income Tax, Excise, FATCA, and CbCR. Team and enterprise licenses with options for API and SSO.',
      keywords:
        'enterprise access, team access, role-based seats, content exports, saved views, API, SSO, IP control, procurement, quote, VAT Law, Income Tax Law, Excise Law, FATCA, CbCR',
      h1: 'Pricing, plans & subscriptions',
      h2: 'Get complete access to Oman tax laws and all Oman tax treaties (as and when made available on the portal)',
    },
    '/search-across-law': {
      title: 'Search Oman Laws & Treaties | VAT, Income Tax, Excise',
      description:
        'Select a jurisdiction and tax law to search structured Oman tax texts. Article-level navigation for VAT Law 121/2020, Income Tax Law (Royal Decree No 28 of 2009, as amended), Excise, FATCA, CbCR.',
      keywords:
        'Oman tax search, Oman VAT search, Oman Income Tax search, Excise search, FATCA search, CbCR search, article-level, filters, cross-references, treaty search',
    },
    '/blogs': {
      title: 'GCC Tax Blog | Treaties, VAT, Corporate Tax, Transfer Pricing',
      description:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
      keywords:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
    },
    '/news/oman': {
      title: 'Oman Tax News | Oman Tax Authority Announcements',
      description:
        'Latest Oman tax news and Oman Tax Authority announcements. VAT, income tax, excise and customs regulatory updates from official Oman tax authority sources.',
      keywords:
        'Oman tax news, Oman Tax Authority news, Oman VAT news, Oman income tax news, Oman excise updates, Oman customs news, Oman tax regulatory updates, Oman tax alerts, Royal Decree Oman tax',
    },
    '/search/Oman/Tax-Treaties': {
      title: 'Oman Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Search official text of Oman tax treaties by partner country. Article-level navigation, filters, and official texts covering withholding, PE, capital gains, and relief.',
      keywords:
        'Oman tax treaties, Oman DTT, Oman DTAA, double taxation agreements Oman, treaty list Oman, withholding tax Oman treaty, PE Oman treaty, capital gains article 13 Oman, elimination of double taxation, treaty index Oman',
    },
    '/laws/GCC/common-customs-agreement': {
      title: 'GCC Common Customs Agreement | Customs union rules & procedures',
      description:
        'Official GCC Common Customs Agreement, parsed and structured: scope, valuation, classification, duty rates, exemptions, origin, transit, warehousing, procedures, penalties, appeals.',
      keywords:
        'GCC Common Customs Agreement, GCC customs union, customs valuation, tariff classification, duty rates, exemptions, rules of origin, transit, warehousing, customs procedures, penalties, appeals',
    },
    '/laws/GCC/common-vat-agreement': {
      title: 'GCC Common VAT Agreement | Unified VAT framework',
      description:
        'Unified GCC VAT framework parsed and structured: scope, place of supply, rates and exemptions, registration, reverse charge, intra GCC trade, refunds and compliance.',
      keywords:
        'GCC Common VAT Agreement, Unified VAT Agreement for the GCC, GCC VAT, place of supply, zero rated supplies, exemptions, VAT registration, VAT groups, reverse charge, intra GCC supplies, imports and exports, input tax refunds, invoicing and records, penalties and disputes',
    },
    '/laws/GCC/common-excise-agreement': {
      title: 'GCC Common Excise Agreement | Selective tax framework',
      description:
        'Unified GCC excise framework: taxable goods and rates, registration, warehouses & suspension, declarations & payment, tax stamps, penalties and refunds.',
      keywords:
        'GCC Common Excise Agreement, GCC excise tax, selective tax GCC, taxable goods, excise rates, registration and licensing, excise warehouse, suspension arrangement, declarations, payment, tax stamps, digital tax stamps, track and trace, offences and penalties, refunds, exemptions, imports and exports, coordination with customs',
    },
    '/laws/oman/income-tax-law-royal-decree-28-of-2009': {
      title: 'Oman Income Tax Law 2009 | Royal Decree 28/2009',
      description:
        'Search Oman Income Tax Law 2009 (Royal Decree 28/2009) with article-level navigation: corporate tax rates, withholding, exemptions, and dispute resolution.',
      keywords:
        'Income Tax Law 2009, Royal Decree 28 of 2009, corporate tax Oman, withholding tax Oman, permanent establishment Oman, tax exemptions, dispute resolution, tax card, returns and assessment, penalties',
    },
    '/laws/oman/vat-law-royal-decree-121-of-2020': {
      title: 'Oman VAT Law | Royal Decree No. 121 of 2020',
      description:
        'Official Oman VAT Law - Royal Decree No. 121 of 2020 parsed and structured. Coverage includes registration, zero-rating, exemptions, returns and penalties.',
      keywords:
        'VAT Law Royal Decree 121 of 2020, Oman VAT, tax invoice, input tax deduction, VAT return Oman, zero rated supplies, exempt supplies, reverse charge Oman, responsible person, VAT refunds',
    },
    '/laws/oman/excise-tax-law-royal-decree-23-of-2019': {
      title: 'Oman Excise Law of 2019 | Royal Decree 23/2019',
      description:
        'Official Oman Excise Tax Law (Royal Decree 23/2019) parsed and structured. Coverage includes taxable goods, rates, tax stamps, returns, and penalties.',
      keywords:
        'Oman Excise Law of 2019, Royal Decree 23/2019, excise tax Oman, selective tax, taxable goods, energy drinks, tobacco, pork, excise returns, digital tax stamps, penalties',
    },
    '/laws/oman/cbcr-law': {
      title: 'Oman CbCR Law | Country-by-Country Reporting Rules',
      description:
        'Search Oman Country-by-Country Reporting (CbCR) regulations. MNE notification requirements, filing deadlines, aggregate data reporting, and penalties.',
      keywords:
        'Oman CbCR Law, Country-by-Country Reporting, MNE reporting Oman, transfer pricing documentation, BEPS Action 13, CbC notification, filing requirements, penalties, Tax Authority Decision 79/2020',
    },
    '/laws/oman/fatca-of-2014-direct': {
      title: 'Oman FATCA Regulations | US Compliance & Reporting',
      description:
        'Official Oman FATCA guidance and regulations. Compliance procedures for financial institutions, due diligence, reporting standards, and US tax interaction.',
      keywords:
        'Oman FATCA, Foreign Account Tax Compliance Act, US tax compliance Oman, financial institutions reporting, due diligence, IRS reporting, intergovernmental agreement',
    },
  },
  'bahraintaxlaws.com': {
    '/': {
      title: 'Bahrain Tax Laws | QDMTT, VAT, Excise, Economic Substance',
      description:
        'Official Bahrain tax texts, parsed and structured: QDMTT Law (Decree 11/2024), VAT Law 48 of 2018, Excise, and Economic Substance with article-level navigation.',
      keywords:
        'Bahrain QDMTT Law Decree 11 of 2024, Bahrain VAT Law 48 of 2018, Pillar Two Bahrain, NBR Bahrain, excise Bahrain, ESR Bahrain, customs Bahrain, tax treaties Bahrain, executive regulations',
      h1: 'Your go-to tax research platform',
      h2: 'Authoritative Bahrain tax laws and treaty research',
      h3: 'QDMTT: Decree Law 11 of 2024, Pillar Two, Top-up Tax\n\nVAT: Law 48 of 2018, invoices, refunds\n\nExcise: law, digital stamps, goods\n\nESR: Economic Substance returns\n\nCustoms: duties and exemptions\n\nTreaties: withholding and relief',
    },
    '/about-us': {
      title: 'About bahraintaxlaws.com | Bahrain tax law research',
      description:
        'We publish Bahrain tax texts from official sources, parsed and structured: QDMTT Law (Decree 11/2024), VAT Law 48 of 2018, Excise, and Treaties with update tracking.',
      keywords:
        'Bahrain tax research, Bahrain tax database, official texts, Bahrain QDMTT Law, Decree Law 11 of 2024, Bahrain VAT Law 48 of 2018, NBR Bahrain, customs Bahrain, excise Bahrain, article-level navigation',
    },
    '/partner-with-us': {
      title: 'Partner with bahraintaxlaws.com | Data licensing and APIs',
      description:
        'License Bahrain tax law content built from official texts. Embed via API, enable SSO and bulk access, co-brand training, and power your research tools.',
      keywords:
        'data licensing, API, SSO, bulk seats, site license, white label, content embedding, tax treaty data, transfer pricing data, enterprise integration, co-branded training',
    },
    '/contact-us': {
      title: 'Contact bahraintaxlaws.com | Support, Licensing & API',
      description:
        'Reach bahraintaxlaws.com for support, sales and partnerships. Ask about licensing, API feeds, and structured Bahrain tax texts on QDMTT, VAT, and treaties.',
      keywords:
        'support, sales, licensing, API, site license, bulk seats, SSO, SCIM, enterprise, data syndication, correction request, partnerships, media',
    },
    '/features': {
      title: 'Features | Bahrain Tax Laws Research Tools',
      description:
        'Official Bahrain tax texts, parsed and structured with article-level navigation, powerful search, filters, cross-references across QDMTT, VAT, Excise, Treaties.',
      keywords:
        'official texts, structured articles, article-level navigation, search filters, cross-references, update history, Bahrain QDMTT Law 11 of 2024, Bahrain VAT Law 48 of 2018, Excise, Treaties',
      h1: 'Bahrain Tax Features',
      h2: 'Built from official Bahrain texts, structured for fast, reliable research. BahrainTaxLaws.com parses and organizes Bahrain tax sources into an article-level experience with jump links, cross-references across laws and treaties, and fast search with smart filters, backed by update tracking and clear release notes so you can see what changed and when.',
    },
    '/pricing': {
      title: 'Bahrain Tax Laws Pricing | Individual, Team, Firm, Enterprise',
      description:
        'Unlock structured Bahrain tax texts: tax treaty, QDMTT, VAT, customs, excise, and treaties. Team and enterprise licenses with options for API and SSO.',
      keywords:
        'enterprise access, team access, role-based seats, content exports, saved views, API, SSO, IP control, procurement, quote, QDMTT Law, VAT Law, Excise, Customs, DTAA',
      h1: 'Pricing, plans & subscriptions',
      h2: 'Get complete access to Bahrain tax laws and all Bahrain tax treaties (as and when made available on the portal)',
    },
    '/search-across-law': {
      title: 'Search Bahrain Laws & Treaties | QDMTT, VAT, Excise',
      description:
        'Select a jurisdiction and tax law to search structured Bahrain tax texts. Article-level navigation for QDMTT Law 11 of 2024, VAT Law 48 of 2018, Excise, Treaties.',
      keywords:
        'Bahrain tax search, Bahrain VAT search, Bahrain QDMTT search, Excise, Customs, Treaties, article-level, filters, cross-references, treaty search, DTAA search',
    },
    '/blogs': {
      title: 'GCC Tax Blog | Treaties, VAT, Corporate Tax, Transfer Pricing',
      description:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
      keywords:
        'Practical guidance, case notes, and how-to articles on GCC tax built from official texts: registration, returns, penalties, treaty relief, TP, customs, excise.',
    },
    '/news/bahrain': {
      title: 'Bahrain Tax News | NBR Announcements & Updates',
      description:
        'Latest Bahrain tax news and National Bureau for Revenue (NBR) announcements. VAT, DMTT, excise and customs regulatory updates from official Bahrain tax authority sources.',
      keywords:
        'Bahrain tax news, NBR news, National Bureau for Revenue announcements, Bahrain VAT news, Bahrain DMTT updates, Pillar Two Bahrain, Bahrain excise news, Bahrain customs updates, Bahrain tax regulatory alerts',
    },
    '/search/Bahrain/Tax-Treaties': {
      title: 'Bahrain Tax Treaties (DTAA) | Double Taxation Agreements',
      description:
        'Find Bahrain official text tax treaties by partner country. Use filters and text search to open article-level pages on WHT, PE, capital gains, and methods of relief.',
      keywords:
        'Bahrain tax treaties, Bahrain DTT, Bahrain DTAA, double taxation agreements Bahrain, treaty list Bahrain, withholding tax Bahrain treaty, PE Bahrain treaty, capital gains article 13 Bahrain, residency tie-breaker, tax credit article 23',
    },
    '/laws/GCC/common-customs-agreement': {
      title: 'GCC Common Customs Agreement | Customs union rules & procedures',
      description:
        'Official GCC Common Customs Agreement, parsed and structured: scope, valuation, classification, duty rates, exemptions, origin, transit, warehousing, procedures, penalties, appeals.',
      keywords:
        'GCC Common Customs Agreement, GCC customs union, customs valuation, tariff classification, duty rates, exemptions, rules of origin, transit, warehousing, customs procedures, penalties, appeals',
    },
    '/laws/GCC/common-vat-agreement': {
      title: 'GCC Common VAT Agreement | Unified VAT framework',
      description:
        'Unified GCC VAT framework parsed and structured: scope, place of supply, rates and exemptions, registration, reverse charge, intra GCC trade, refunds and compliance.',
      keywords:
        'GCC Common VAT Agreement, Unified VAT Agreement for the GCC, GCC VAT, place of supply, zero rated supplies, exemptions, VAT registration, VAT groups, reverse charge, intra GCC supplies, imports and exports, input tax refunds, invoicing and records, penalties and disputes',
    },
    '/laws/GCC/common-excise-agreement': {
      title: 'GCC Common Excise Agreement | Selective tax framework',
      description:
        'Unified GCC excise framework: taxable goods and rates, registration, warehouses & suspension, declarations & payment, tax stamps, penalties and refunds.',
      keywords:
        'GCC Common Excise Agreement, GCC excise tax, selective tax GCC, taxable goods, excise rates, registration and licensing, excise warehouse, suspension arrangement, declarations, payment, tax stamps, digital tax stamps, track and trace, offences and penalties, refunds, exemptions, imports and exports, coordination with customs',
    },
    '/laws/bahrain/dmtt-law-11-of-2024': {
      title: 'Bahrain DMTT Law (Decree Law No. 11 of 2024) | Pillar Two',
      description:
        'Authoritative Bahrain DMTT Law (Decree Law No. 11 of 2024): scope, MNE obligations, computation, top-up tax filing steps and NBR guidance.',
      keywords:
        'Bahrain QDMTT Law, Decree Law 11 of 2024, Pillar Two Bahrain, MNE tax Bahrain, top-up tax, GloBE rules Bahrain, NBR guidance, safe harbours, effective tax rate, multinational enterprises',
    },
    '/laws/bahrain/vat-law-48-of-2018': {
      title: 'Bahrain VAT Law 48 of 2018 | Invoicing, Returns, Refunds',
      description:
        'Search Bahrain VAT Law 48 of 2018 and regulations with article-level navigation: registration, place of supply, zero-rating, refunds and penalties.',
      keywords:
        'Bahrain VAT Law 48 of 2018, NBR VAT, VAT registration Bahrain, tax invoice, basic rate, zero rate, VAT return Bahrain, penalties, input tax recovery, reverse charge Bahrain',
    },
  },
}

export default SEO_DATA
